type ModalBodyProps = {
  children: React.ReactNode;
};

export default function ModalBody({ children }: ModalBodyProps) {
  return <div className="modal__body">{children}</div>;
}
